import React, { useEffect, useState } from "react";

import axiosLead from "../../../../../services/lead";
import * as Styles from "../../../styles";

interface Props {
  desqualificarId: Function;
  isLeadScreen: boolean;
}

export function DesqualificarForm(props: Props) {
  const [motivosDesqualificacao, setMotivoDesqualificacao] = useState<
    Array<{ id: string; nome: string }>
  >([]);
  const [isConcluded, setIsConcluded] = useState<boolean>(false);
  const [desqualificarId, setDesqualificarId] = useState<any>("");

  useEffect(() => {
    requestDesqualificacao();
  }, []);

  useEffect(() => {
    props.desqualificarId(desqualificarId?.id);
  }, [desqualificarId, props.desqualificarId]);

  const requestDesqualificacao = async () => {
    try {
      const response = await axiosLead.GetDesqualificacao();
      const motivosDesqualificacao = response.data.data;
      setMotivoDesqualificacao(motivosDesqualificacao);

      const todosCamposPreenchidos = verificarCamposPreenchidos(
        motivosDesqualificacao
      );
      if (todosCamposPreenchidos) {
        if (props.isLeadScreen) {
          window.location.href = "/transferencia-concluida/desqualificado";
        } else {
          setIsConcluded(!isConcluded);
        }
      } else {
        console.log("Por favor, preencha todos os campos necessários.");
      }
    } catch (error) {
      console.log("Erro ao listar zonas.");
    }
  };

  const verificarCamposPreenchidos = (motivosDesqualificacao: any) => {
    if (
      motivosDesqualificacao &&
      motivosDesqualificacao.id &&
      motivosDesqualificacao.descricao
    ) {
      return true;
    }
    return false;
  };

  return (
    <>
      <Styles.TransferComponent style={{ minHeight: 0 }}>
        <Styles.LabelText>Motivo *</Styles.LabelText>
        <Styles.Autocomplete
          id="combo-box-demo"
          defaultValue={{
            nome: "Selecione um motivo",
            id: "1",
          }}
          disableClearable
          options={motivosDesqualificacao}
          value={desqualificarId}
          renderInput={(params: any) => (
            <>
              <Styles.TextField
                size="small"
                InputLabelProps={{ shrink: false }}
                variant="outlined"
                {...params}
                label="Resultado *"
                required
              />
            </>
          )}
          getOptionSelected={(option: any) => option.nome}
          getOptionLabel={(option: any) => option.nome || ""}
          // @ts-ignore
          onChange={(event: any, newValue: string | null) => {
            setDesqualificarId(newValue);
          }}
        />
      </Styles.TransferComponent>
    </>
  );
}
